export function validateContact(contact) {
    const value = (contact || '').trim();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phonePattern = /^\+?\d{7,15}$/;
    const phone = value.replace(/[\s().-]/g, '');
    if (!value) {
        return 'contact_required';
    } else if (!emailPattern.test(value) && !phonePattern.test(phone)) {
        return 'contact_invalid';
    }
    return '';
}

export function validateForm(form) {
    if (!form.suggestion || !form.suggestion.trim()) {
        return { valid: false, message: 'suggestion_required' };
    }
    if (!form.name || !form.name.trim()) {
        return { valid: false, message: 'name_required' };
    }
    if (typeof form.canContact !== 'boolean') {
        return { valid: false, message: 'contact_permission_required' };
    }
    const contactError = validateContact(form.contact);
    if (contactError) {
        return { valid: false, message: contactError };
    }
    return { valid: true };
}
